<template>
  <!-- 确认收货弹框 -->
  <el-dialog
    class="sureDialog"
    title=""
    :visible.sync="logistDialog"
    :close-on-click-modal="false"
    width="480px"
  >
    <div class="logistics">
      <div class="title">确认收到货了吗？</div>
      <div class="desc">为了保证您的权益，请收到商品检查无误后再确认收货</div>
      <div class="actionWrap">
        <span class="btns" @click="logistDialog=false">取消</span>
        <span class="savebtn" @click="sureResvOrder()">确定</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
/*global http protocol */
export default {
  props: ['name'],
  data() {
    return {
      logistDialog: false,
      currentOrderId: null,
      isRepeat: false
    }
  },
  methods: {
    showDialog(orderId) {
      this.currentOrderId = orderId
      this.logistDialog = true
    },
    // 确认收货
    sureResvOrder() {
      if (this.isRepeat) {
        return
      }
      this.sureLogist()
      // if (this.name === 'order') {
      //   protocol.param_findShopOrderDetailInfo.param.orderId = this.currentOrderId
      //   http
      //     .postFrontMall(protocol.param_findShopOrderDetailInfo)
      //     .then(response => {
      //       const { code, message, value } = response.data
      //       if (code === 0 || code === '0') {
      //         const id = value.commodityAndRec.content.length ? value.commodityAndRec.content[0].orderDetailId : {}
      //         this.sureLogist(id)
      //       } else {
      //         this.$message(message)
      //       }
      //     })
      //     .catch(() => {})
      // } else {
      //   this.sureLogist(this.currentOrderId)
      // }
    },
    sureLogist() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      protocol.param_confirmOrder.param.orderDetailId = this.currentOrderId
      http.postFrontMall(protocol.param_confirmOrder).then((response) => {
        const { code, message } = response.data
        this.$message(message)
        if (Number(code) === 0) {
          this.$emit('reQueryList', 1)
          setTimeout(() => {
            this.logistDialog = false
            this.isRepeat = false
          }, 1500)
        } else {
          this.isRepeat = false
        }
      }).catch(() => {
        this.isRepeat = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.sureDialog{
  /deep/.el-dialog{
		background: #424556!important;
		border-radius: 8px 8px 8px 8px;
	}
	/deep/.el-dialog__header{
		display: none;
	}
	/deep/.el-dialog__body{
		padding:40px;
	}
	.title{
		font-size: 24px;
		font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
	}
  .desc{
    margin-top:20px;
    text-align: center;
    font-size: 20px;
    font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 30px;
  }
  .actionWrap{
		margin-top:40px;
		display: flex;
		justify-content: center;
		.btns{
			display: inline-block;
			width: 95px;
			height: 40px;
			background: #FCECC8;
			border-radius: 4px 4px 4px 4px;
			border: 1px solid #E4CA91;
			font-size: 14px;
			font-family: PingFang HK-Medium, PingFang HK;
			font-weight: 500;
			color: #5E4207;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
		}
	}

	.savebtn{
		margin-left: 20px;
		width:95px;
		display: inline-block;
		height: 40px;
		background: #E4CA91;
		border-radius: 4px 4px 4px 4px;
		font-size: 14px;
		font-family: PingFang HK-Medium, PingFang HK;
		font-weight: 500;
		color: #5E4207;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
	}
}
</style>
